/* eslint-disable react/display-name */
import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { useNavigate } from 'react-router'

import { Close, Home } from '@mui/icons-material'
import { Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@mui/material'
import { makeStyles } from '@mui/styles'

const drawerWidth = 270
const useStyles   = makeStyles(() => {
  const classList = {
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    drawerPaper: {
      width: drawerWidth
    },
    drawerHeader: {
      display: 'flex',
      alignSelf: 'flex-end'
    }
  }
  return classList
})

const SideBar = forwardRef((props, ref) => {
  const classes  = useStyles()
  const navigate = useNavigate()

  const [drawerOpen, setDrawerOpen] = useState(false)

  useImperativeHandle(ref, () => ({

    toggleDrawer () {
      setDrawerOpen((prev) => !prev)
    }
  }))

  const handleDrawerClose = () => {
    setDrawerOpen(false)
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={drawerOpen}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <List dense>
        <ListItem>
          <ListItemText style={{ minHeight: 20 }} primary="KolayYolla" secondary="QR Menü" />
          <ListItemSecondaryAction>
            <IconButton onClick={handleDrawerClose}>
              <Close />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>

        <Divider />

        <ListItem
          button
          key="home"
          onClick={() => {
            handleDrawerClose()
            navigate('/')
          }}
        >
          <ListItemIcon><Home /></ListItemIcon>
          <ListItemText primary="Ana Sayfa" />
        </ListItem>

      </List>

    </Drawer>

  )
})
export default SideBar
